export default "__VITE_ASSET__LH0lWpx9__"